module.exports = __webpack_public_path__ + "assets/media/purple-arrow-3.af26111f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/OnboardingPlaybookDemoRequestStep/purple-arrow-3.svg
// module id = 3149
// module chunks = 0